import { HttpService } from 'app/services';

export const ANNOUNCEMENT_GET_ACTIVE = '@ANNOUNCEMENT/GET_ACTIVE';
export const ANNOUNCEMENT_GET_ACTIVE_SUCCESS = '@ANNOUNCEMENT/GET_ACTIVE_SUCCESS';
export const ANNOUNCEMENT_GET_ACTIVE_FAIL = '@ANNOUNCEMENT/GET_ACTIVE_FAIL';

export const getActiveAnnouncement = () => {
  return (dispatch) => {
    dispatch({ type: ANNOUNCEMENT_GET_ACTIVE });
    HttpService.get('/api/announcements/active', {}, { cancelToken: 'getActiveAnnouncement' })
      .then((resp) => {
        dispatch({
          type: ANNOUNCEMENT_GET_ACTIVE_SUCCESS,
          payload: resp.data || null,
        });
      })
      .catch(() => {
        dispatch({ type: ANNOUNCEMENT_GET_ACTIVE_FAIL, payload: { message: 'error' } });
      });
  };
};
